import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './feature/home/home.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  
  {
     path: '',
     component: HomeComponent,
     canActivate:[MsalGuard]

    // path: '',
    // loadChildren: './feature/home/home.module#HomeModule',
    // canActivate: [REBAR_AUTH_GUARD]
  },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: !isIframe ? 'enabledNonBlocking' : 'disabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }